// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconWineGlass = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 25', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.644.01a1.5 1.5 0 00-1.485 1.272l-.787 5.131a7.709 7.709 0 00.437 3.976 7.719 7.719 0 006.441 4.879v7.242H9a.75.75 0 000 1.5h6a.75.75 0 000-1.5h-2.25v-7.243a7.718 7.718 0 006.878-8.854l-.789-5.131A1.5 1.5 0 0017.357.01H6.644zm11.405 6l-.692-4.5H6.64l-.69 4.5H18.05zM5.783 7.51a6.219 6.219 0 1012.434 0H5.783z"
      fill="currentColor"
    />
  );
export default SvgIconWineGlass;
